var debug = true;
var grid_container;
var listerergroup = [];



if (!debug) console.log = function () {};
if (typeof Alfa2017 == 'undefined') var Alfa2017 = {};

/*
 *
 * LOAN SIMULATOR SCRIPT
 * TKHD/GMX
 * Custom for Alfa Romeo or other FCA brand
 *
 * OVERVIEW
 * - share dynamic data (php preference) thru JSON
 * - loan simulator contains two part, model selector and calculator
 * - model selector lets users to select model
 * - calculator will gather info and send info to JACCS server thru API
 *
 * PROCESS
 * 1 : setup
 * 2 : add listener events - updateLayout
 * 3 : initLoanSimulator => initModelSelector and initCalculator
 * 4 : setup get/set global events
 *
 */



Alfa2017.LS1 = {

  val: {
    session_max_slot: 3,
    session_current_slot: 1,
    session_values: {
      1: {},
      2: {},
      3: {}
    },
    session_payment_type: 1,
    session_current_slick_slot: 1,
    first_time: true,
    slick_default_value: {
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1
    }
  },
  setup: function () {

    if ($('.loan-simulator').is("*")) {
      Alfa2017.LS1.initLoanSimulator();
      $('.slick').slick(Alfa2017.LS1.val.slick_default_value);
      $('.note-0').css("display", "none");
      $('.calculation-form').hide();
      Alfa2017.Util.resizegroup.push(Alfa2017.LS1.updateLayout);
      Alfa2017.Util.scrollgroup.push(Alfa2017.LS1.updateLayout);
    }

    if ($('.loan-description').is("*")) {
      Alfa2017.Util.resizegroup.push(Alfa2017.LS1.updateDescriptionLayout);
      Alfa2017.Util.scrollgroup.push(Alfa2017.LS1.updateDescriptionLayout);
    }


  },

  updateDescriptionLayout: function () {
    var defH = $('.target-obj-1').height();
    var myH = ($(window).width() > 768) ? (defH / 2) - 20 : 0;
    $('.fix-imgwrap').css({
      "margin-top": myH
    })
  },
  // listener event to adjust layout on scroll and resize

  updateLayout: function () {

    var _p = $('.focus-wrap');
    var _h = $(_p).height();

    $('.covers').css({
      "height": _h - 25
    });
    $('.focus-wrap .bg').css({
      "height": _h
    });
    var _imgH = ($('.img-slick').height() / 2) + "px";
    $('.slick-wrap .slick-prev, .slick-wrap .slick-next').css({
      "top": _imgH
    })

    $('.img-slick').width($('.slick-wrap').width());


  },
  initLoanSimulator: function () {

    Alfa2017.LS1.initModelSelector();
    Alfa2017.LS1.initCalculator();

    // with query, set up proper model and loan

    var mytimer;

    function trigger() {
      $('.select-model').each(function () {
        var mymodel = $(this).data('model');
        if (selected_model == mymodel) {
          $(this).trigger("click");
        }
      });
      if (selected_type != 0) {
        //console.log("test nats");
        $('#loan-type-1').val(selected_type)
          .trigger('change');
        $('#payment-times-' + selected_type + '-1').val(selected_terms)
          .trigger('change');
      }
      if (selected_sueokirate != 0) {

        $('.sueoki-rate-input-1').val(selected_sueokirate);

        Alfa2017.LS1.checkSueokiRate();
        Alfa2017.LS1.udpateSueokiGaku();
      }
    };

    if (selected_model == "N/A") {

    } else {
      clearTimeout(mytimer);
      mytimer = setTimeout(trigger, 1000);
    };
  },

  // GET/SET events

  nextSlot: function () {
    if (Alfa2017.LS1.val.session_current_slot + 1 > Alfa2017.LS1.val.session_max_slot) {
      Alfa2017.LS1.val.session_current_slot = 1;
    } else {
      Alfa2017.LS1.val.session_current_slot = Alfa2017.LS1.val.session_current_slot + 1;
    };
    return Alfa2017.LS1.val.session_current_slot;
  },
  getSlot: function () {
    return Alfa2017.LS1.val.session_current_slot;
  },
  setSlot: function (_n) {
    if (_n >= 1 && _n <= Alfa2017.LS1.val.session_max_slot) {

      Alfa2017.LS1.val.session_current_slot = _n;

      $('.focus-selector').removeClass("active");
      var _tgt = ".focus-" + _n;
      $(_tgt).addClass("active");

      $('.form-wrap').removeClass("active");
      var _tgt2 = ".form-" + _n;
      $(_tgt2).addClass("active");


    } else {
      return false;
    }
  },
  addSessionValue: function (_id, _label, _value) {
    Alfa2017.LS1.val.session_values[_id][_label] = _value;
  },
  getSessionValue: function () {
    return Alfa2017.LS1.val.session_values;
  },
  getSingleSessionValue: function (_id) {
    return Alfa2017.LS1.val.session_values[_id];
  },
  setSessionValue: function (_id, _label, _value) {
    Alfa2017.LS1.val.session_values[_id][_label] = _value;

    if (_label == "isEdited") {
      //window.console.log ( "_id => " + _id );
      //window.console.log ( "change value= >" + Alfa2017.LS1.val.session_values[_id][_label] );
      var _myname = '.btn-calculate-' + _id;
      $(_myname).removeClass('disabled');
    }
  },
  getCurrentSlickSlot: function (_id) {
    return Alfa2017.LS1.val.session_current_slick_slot;
  },
  setCurrentSlickSlot: function (_id) {
    Alfa2017.LS1.val.session_current_slick_slot = _id;
  },


  // slick in calculator
  // need this because calculator is not visbile at first

  initFocusSlick: function () {


    if (Alfa2017.LS1.val.first_time == true) {

      $('.focus-slick').slick({
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 840,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
      Alfa2017.LS1.val.first_time = false;
    }
  },


  // initialize model selector

  initModelSelector: function () {

    $('.back-to-selector').click(function (e) {
      e.preventDefault();
      $('.calculation-form').hide();
      $('.model-selector').show();

    });

    $('.focus-selector').hover(function () {

    }, function () {

    });

    // coming back from calculation part
    // changing focus to select model

    $('.select-focus').click(function (e) {
      e.preventDefault();
      var _id = $(this).data("id");
      Alfa2017.LS1.setSlot(_id);
    });
    $('.select-new-model').click(function (e) {
      e.preventDefault();
      var _id = $(this).data("id");
      Alfa2017.LS1.setSlot(_id);

      $('.slick').slick('resize');

      $('.calculation-form').hide();
      $('.model-selector').show();
      Alfa2017.LS1.updateLayout();
      $('.slick').slick('resize');


      var _tgt = ".focus-" + _id;
      $(_tgt).find(".covers").hide();
      $(_tgt).find(".info-inner").show();



      var totopnum = $('.model-selector').offset().top;

      $('html, body').animate({
        scrollTop: totopnum
      }, 50, function () {

        $('.slick').slick('resize');
        Alfa2017.LS1.updateLayout();
      });




      $('.slick').slick("unslick");
      $('.slick').slick();
      //$('.slick').slick('reinit');
      $('.slick').slick("slickGoTo", Alfa2017.LS1.getCurrentSlickSlot());
    });

    // select model
    // save model related info into "session value"

    $('.select-model').click(function (e) {

      e.preventDefault();
      var _id = $(this).data('model');
      var _slick_slot = $(this).data('slick-slot');
      var curslot = Alfa2017.LS1.getSlot();
      var myloans = models[_id]['loanplans'];
      var targetForm = '.focus-' + curslot;
      var mymodelimg = "img/" + lineup[models[_id]['lineup']]['img'];





      Alfa2017.LS1.addSessionValue(curslot, 'model', _id);
      Alfa2017.LS1.addSessionValue(curslot, 'price', models[_id]['price']);
      Alfa2017.LS1.addSessionValue(curslot, 'notax', models[_id]['notax']);
      Alfa2017.LS1.addSessionValue(curslot, 'name', models[_id]['name']);
      Alfa2017.LS1.addSessionValue(curslot, 'nameJ', models[_id]['nameJ']);
      Alfa2017.LS1.addSessionValue(curslot, 'lineup', models[_id]['lineup']);
      Alfa2017.LS1.addSessionValue(curslot, 'isEdited', true);
      Alfa2017.LS1.setCurrentSlickSlot(_slick_slot);
      //window.console.log ( Alfa2017.LS1.getCurrentSlickSlot() );


      // insert model into to, forcus selector in  calculation part
      // and display calculation part and hide model selector part

      $(targetForm).show();
      $(targetForm).find('.body-price .txt')
        .text(accounting.formatNumber(models[_id]['price']));
      $(targetForm).find('.body-name .txt')
        .text(models[_id]['name']);
      $(targetForm).find('.selected-img')
        .attr("src", mymodelimg);
      $(targetForm).find('.selected-img').data("src", mymodelimg);

      var totopnum = $('.content-area').offset().top;


      // adjust payment times

      $(targetForm).find('.payment-times-wrap-all').hide();
      //for(var k in myloans ){
      for (var k = 0; k < myloans.length; k++) {
        var mt = ".payment-times-wrap-" + loanslug[k];
        $(targetForm).find(mt).show();
      }


      // adjust loan type selector

      var newme = "#loan-type-" + curslot + " option";
      //myloans.push('allLoan'); //temporarily hide 1.9% loan type

      $(newme).each(function () {
        Array.prototype.in_array = function (val) {
          for (var i = 0, l = this.length; i < l; i++) {
            if (this[i] == val) return true;
          };
          return false;
        }
        
        if (myloans.in_array($(this).val())) {
          //$(this).removeAttr('disabled');
          $(this).show();
        } else {
          //$(this).attr("disabled", "disabled");
          $(this).hide();
        }
      });

      
      // re-select default loan type for the model
      $('#loan-type-' + curslot).val(myloans[0]).trigger('change');
      var c = 0;
      var myfirstkey = "";
      for (var v in loaninfo[myloans[0]]['payments']) {

        c++;
        if (c == 1) {
          myfirstkey = v;
          break;
        }
      }
      var myfirstpaymentinfo = loaninfo[myloans[0]]['payments'][myfirstkey];
      var myrateS = loaninfo[myloans[0]]['payments'][myfirstkey]['maxrate'];

      $('#payment-times-' + myloans[0] + "-" + curslot).val(v).trigger('change');
      $('.sueoki-rate-input-' + curslot).val(myrateS);
      Alfa2017.LS1.udpateSueokiGaku();


      // add default sueokigaku
      //var defaultSueokiGaku = models[_id]['price'] * 0.2;
      //$('.sueoki-price-' + curslot ).text( defaultSueokiGaku );

      $('.calculation-form').show();
      $('.model-selector').hide();
      $('html, body').animate({
        scrollTop: totopnum
      }, 500);

      Alfa2017.LS1.initFocusSlick()

    });
  },


  udpateSueokiGaku: function () {

    var curslot = Alfa2017.LS1.getSlot();
    var _modelinfo = Alfa2017.LS1.getSingleSessionValue(curslot);
    var _newtarg = '.sueoki-rate-input-' + curslot;
    var _val = parseInt($(_newtarg).val());

    var _option = $('#option-' + curslot);
    var _option_val = $(_option).val();

    _modelinfo['price'] = parseInt(_modelinfo['price']);
    _option_val = parseInt(_option_val);
    var _subtotal = _modelinfo['price'] + _option_val;

    var defaultSueokiGaku = _subtotal * _val;
    defaultSueokiGaku = Math.floor(defaultSueokiGaku / 100000)*1000;
    $('.sueoki-price-' + curslot).text(accounting.formatNumber(defaultSueokiGaku));

    Alfa2017.LS1.setSessionValue(curslot, "isEdited", true);
  },


  checkSueokiRate: function () {


    var curslot = Alfa2017.LS1.getSlot();
    var _modelinfo = Alfa2017.LS1.getSingleSessionValue(curslot);
    var _newtarg = '.sueoki-rate-input-' + curslot;
    var _min = parseInt($(_newtarg).attr("data-min"));
    //var _min = 5;
    var _max = parseInt($(_newtarg).attr("data-max"));
    var _val = parseInt($(_newtarg).val());

    //window.console.log ( "_val => " + _val );
    //window.console.log ( "_min => " + _min );
    //window.console.log ( "_max => " + _max );

    if (_val < _min || _val > _max) {
      $(_newtarg).val(_max);
    } else {
      $(_newtarg).val(parseInt(_val));
    }

  },

  // calculation part
  // mainly gather info and send to JACCS API
  // and retrieve value and display

  initCalculator: function () {


    $('.sueoki-rate-input').blur(function () {
      Alfa2017.LS1.checkSueokiRate();
      Alfa2017.LS1.udpateSueokiGaku();
    });



    $('.option-input').each(function () {
      $(this).blur(function () {
        var _val = $(this).val();

        if (_val == "") {
          $(this).val(0);
        } else {
          $(this).val(accounting.formatNumber(_val));
        };

        Alfa2017.LS1.checkSueokiRate();
        Alfa2017.LS1.udpateSueokiGaku();

      });

      $(this).keypress(function () {
        var _val = $(this).val();
        //_val = parseInt( _val );
        if (_val == "") {
          $(this).val(0);
        } else {
          $(this).val(accounting.formatNumber(_val));
        };
        //Alfa2017.LS1.checkSueokiRate();
        //Alfa2017.LS1.udpateSueokiGaku();

      });
    });

    $('.downpayment-input').each(function () {
      $(this).blur(function () {
        var _val = $(this).val();

        if (_val == "") {
          $(this).val(0);
        } else {
          $(this).val(accounting.formatNumber(_val));
        };
        var curslot = Alfa2017.LS1.getSlot();
        Alfa2017.LS1.setSessionValue(curslot, "isEdited", true);
      });

      $(this).keypress(function () {
        var _val = $(this).val();
        //_val = parseInt( _val );
        if (_val == "") {
          $(this).val(0);
        } else {
          $(this).val(accounting.formatNumber(_val));
        };
        var curslot = Alfa2017.LS1.getSlot();
        Alfa2017.LS1.setSessionValue(curslot, "isEdited", true);
      });
    });

    $('.bonusextra-input').each(function () {
      $(this).blur(function () {
        var _val = $(this).val();

        if (_val == "") {
          $(this).val(0);
        } else {
          $(this).val(accounting.formatNumber(_val));
        };
        var curslot = Alfa2017.LS1.getSlot();
        Alfa2017.LS1.setSessionValue(curslot, "isEdited", true);
      });

      $(this).keypress(function () {
        var _val = $(this).val();
        //_val = parseInt( _val );
        if (_val == "") {
          $(this).val(0);
        } else {
          $(this).val(accounting.formatNumber(_val));
        };
        var curslot = Alfa2017.LS1.getSlot();
        Alfa2017.LS1.setSessionValue(curslot, "isEdited", true);
      });
    });

    // when calculation button clicked

    $('.btn-calculate').click(function (e) {

      if ($(this).hasClass("disabled")) {
        return false;
      }

      e.preventDefault();
      var _id = $(this).data("id");
      var _path = '/loan/simulator/api.php';
      var _myname = '.btn-calculate-' + _id;
      var _data = {};
      var _modeldata = Alfa2017.LS1.getSingleSessionValue(_id);
      var _tgtrslt = ".form-" + _id;
      var _earnestCost = $('#downpayment-' + _id).val();
      var _bonus = $('#bonus-' + _id).val();
      var _plan = $('#loan-type-' + _id).val();
      var _option = $('#option-' + _id).val();
      var _terms = $('#payment-times-' + _plan + '-' + _id).val()
      var _rate = loaninfo[_plan]['rate'];
      var _sueoki_rate = $('#sueoki-rate-' + _id).val();
      var _sueoki_gaku = $('.sueoki-price-' + _id).text();


      $(_myname).addClass("disabled");


      _data['firstMonth_month'] = loanStartMonth;
      _data['firstMonth_year'] = loanStartYear;
      _data['bonusMonthSummer'] = 7;
      _data['bonusMonthWinter'] = 12;
      _data['plan'] = loaninfo[_plan]['planID'];
      _data['rate'] = _rate;
      _data['terms'] = _terms;
      _data['earnestCost'] = _earnestCost;
      _data['bonusAdditionalCost'] = _bonus;
      _data['totalBasePrice'] = _modeldata['price'];
      _data['totalNotaxPrice'] = _modeldata['notax'];
      _data['optionCost'] = _option;
      _data['sueokiRate'] = _sueoki_rate;
      _data['sueokiAmount'] = _sueoki_gaku;


      var _base;

      // send to API

      $.ajax({

        type: "POST",
        url: _path,
        data: _data,
        dataType: "json",

        // API GOOD
        success: function (_json) {

          var _result = _json.result;

          if (_result == true) {

            // set up result info layouts
            //
            _base = $('.system-template-sueoki').html();
            $(_tgtrslt).find('.inner-result').html(_base);

            if (loaninfo[_plan]['planID'] == 1) {
              $('.sueoki-dependant').show();
            } else {
              $('.sueoki-dependant').hide();
            }

            $(_tgtrslt).find('.model span').text(_modeldata['name']);
            $(_tgtrslt).find('.loanType span').text(loaninfo[_plan]['name']);
            $(_tgtrslt).find('.loanRate span').text(loaninfo[_plan]['rate']);
            $(_tgtrslt).find('.totalPrice span').text(accounting.formatNumber(_json.data.totalPrice));
            $(_tgtrslt).find('.optionTotal span').text(accounting.formatNumber(_json.data.optionTotal));
            $(_tgtrslt).find('.allTotal span').text(accounting.formatNumber(_json.data.allTotal));
            $(_tgtrslt).find('.sueokigaku span').text(accounting.formatNumber(_json.data.sueokigaku));
            $(_tgtrslt).find('.sueokiritsu span').text(accounting.formatNumber(_json.data.sueokiritsu));
            $(_tgtrslt).find('.loanPrincipal span').text(accounting.formatNumber(_json.data.loanPrincipal));
            $(_tgtrslt).find('.payment1st span').text(accounting.formatNumber(_json.data.payment1st));
            $(_tgtrslt).find('.paymentMonthly span').text(accounting.formatNumber(_json.data.paymentMonthly));
            $(_tgtrslt).find('.bonusAdditionalCost span').text(accounting.formatNumber(_json.data.bonusAdditionalCost));
            $(_tgtrslt).find('.numOfBonus span').text(_json.data.numOfBonus);
            $(_tgtrslt).find('.installmentsFee span').text(accounting.formatNumber(_json.data.installmentsFee));
            $(_tgtrslt).find('.installmentsTotal span').text(accounting.formatNumber(_json.data.installmentsTotal));
            $(_tgtrslt).find('.totalPayments span').text(accounting.formatNumber(_json.data.totalPayments));
            $(_tgtrslt).find('.paymentPeriod span').text(_json.data.paymentPeriod);
            $(_tgtrslt).find('.btn-wrap').show();
            $(_tgtrslt).find('.additional-note').show();

            // set up return URL for lead form
            var mytarget = '.form-' + _id;
            var returnURLparams = jQuery.param({
              model: _modeldata['model'],
              type: _plan,
              terms: _terms,
              downpayment: accounting.unformat(_earnestCost),
              bonus: accounting.unformat(_bonus),
              option: accounting.unformat(_option),
              sueokirate: accounting.unformat(_sueoki_rate)

            });

            var returnURL = api_return_url + "?" + returnURLparams;
            //window.console.log ( _plan + "_plan");
            var sueokiData = (_plan == "easyLoan") ? "0" : _json.data.sueokiritsu;

            // set up query for Lead form
            var toSend = {
              loantype: _json.data.loanType,
              terms: _terms,
              loanrate: loaninfo[_plan]['rate'],
              model: _modeldata['name'],
              totalprice: _json.data.totalPrice,
              optiontotal: _json.data.optionTotal,
              alltotal: _json.data.allTotal,
              sueokigaku: accounting.unformat(_sueoki_gaku),
              sueokiritsu: sueokiData,
              //sueokiritsu:          _json.data.sueokiritsu,
              //loanprincipal:        _json.data.loanPrincipal,
              loanprincipal: accounting.unformat(_earnestCost),
              payment1st: _json.data.payment1st,
              paymentmonthly: _json.data.paymentMonthly,
              bonusadditionalcost: _json.data.bonusAdditionalCost,
              numofbonus: _json.data.numOfBonus,
              downpayment: accounting.unformat(_earnestCost),
              paymentlast: accounting.unformat(_json.data.paymentLast),
              installmentsfee: _json.data.installmentsFee,
              installmentstotal: _json.data.installmentsTotal,
              totalpayments: _json.data.totalPayments,
              paymentperiod: _json.data.paymentPeriod,
              url: encodeURI(returnURL)
            };

            if (fromODS) toSend.dealer_code = dealer_code;
            var params = jQuery.param(toSend);


            // create redirect URL for email
            //  _modeldata['lineup'].includes("giulia")
            var newurl = (_modeldata['lineup'].indexOf("giulia") > -1) ? lead_form_giuila_url : lead_form_url;
            //var newurl = (  _modeldata['lineup'].includes("giulia") ) ?  lead_form_giuila_url :  lead_form_url ;
            newurl = newurl + "?" + params;
            //window.console.log ( params  );

            // window.console.log ( newurl  );
            var defredirect = api_return_url + "redirect";
            var shoturl = defredirect + "/" + _modeldata['model'] + "/" + _plan +
              "/" + _terms + "/" + accounting.unformat(_earnestCost) + "/" + accounting.unformat(_bonus) +
              "/" + accounting.unformat(_option) + "/" + accounting.unformat(_sueoki_rate);

            // update links created dynamically
            var mailto = "mailto:address?subject=ローン&body=" + shoturl;
            $(mytarget).find('.send-lead').attr("href", newurl);
            $(mytarget).find('.send-email').attr("href", mailto);



            var dealer_url_to_change = (_modeldata['lineup'] == "giulia") ? dealer_giulia_url : dealer_url;

            $(_tgtrslt).find('.find-dealer').attr("href", dealer_url_to_change);

          } else {

            // parameter error

            _base = $('.system-template-error').html();
            $(_tgtrslt).find('.inner-result').html(_base);
            $('.error').text(_json.data);
            $(_tgtrslt).find('.lead-btn-wrap').hide();
            $(_tgtrslt).find('.additional-note').hide();

          }
        },

        // system error
        error: function (err) {
          _base = $('.system-template-system-error').html();
          $('.error').text(err);
        }
      });
    });


    // on change loan type

    $('.loan-type-selector').change(function () {

      var curslot = Alfa2017.LS1.getSlot();
      var val = $(this).val();
      var target = $(this).data("target");
      var distarget = '.payment-sueoki-wrap-' + curslot;
      /*console.log("loan info");
      console.log(loaninfo);
      console.log('val:',val);
      console.log('loaninfo',loaninfo[val]['planID']);*/
      if (loaninfo[val]['planID'] == 0) {
        $(distarget).hide();
      } else {
        $(distarget).show();
      }

      for (var k = 0; k <= loanslug.length; k++) {
        var key = loanslug[k];
        var value = loaninfo[key];
        var sel = '.payment-times-wrap-' + key;
        var txt = '.note-' + key;

        if (key == val) {
          $(target).find(sel).show();
          $(target).find(txt).show();

          var thisPayTimes = $(target).find(sel).find('.payment-times');
          var thisPayTimesVal = thisPayTimes.val();
          var loantype = thisPayTimes.data("loantype");
          var _sueokiinput = $(target).find(".sueoki-rate-input");
          var _max = loaninfo[loantype]['payments'][thisPayTimesVal]['maxrate'];
          var _min = loaninfo[loantype]['payments'][thisPayTimesVal]['minrate'];

          $(_sueokiinput).attr("data-max", _max);
          $(_sueokiinput).attr("data-min", _min);
          $(_sueokiinput).val(_max);
          $(target).find('.max-percentage').text(_max);

          Alfa2017.LS1.checkSueokiRate();
          Alfa2017.LS1.udpateSueokiGaku();

        } else {
          $(target).find(sel).hide();
          $(target).find(txt).hide();
        }
      }
      Alfa2017.LS1.setSessionValue(curslot, "isEdited", true);
    });
    // on change payment times

    $('.payment-times').change(function () {
      var curslot = Alfa2017.LS1.getSlot();
      var _tgtrslt = $(this).data("target");
      var _loantype = $(this).data("loantype");
      var _val = $(this).val();
      var _id = $(this).data('id');
      var _modelinfo = Alfa2017.LS1.getSingleSessionValue(_id);
      var _sueokiinput = $(_tgtrslt).find(".sueoki-rate-input");
      var _max = loaninfo[_loantype]['payments'][_val]['maxrate'];
      var _min = loaninfo[_loantype]['payments'][_val]['minrate'];

      $(_sueokiinput).attr("data-max", _max);
      $(_sueokiinput).attr("data-min", _min);
      //$(_tgtrslt ).find('.min-percentage').text ( _min );
      $(_tgtrslt).find('.max-percentage').text(_max);

      Alfa2017.LS1.checkSueokiRate();
      Alfa2017.LS1.udpateSueokiGaku();

      Alfa2017.LS1.setSessionValue(curslot, "isEdited", true);

    })

    // print function

    $('.print-it').click(function (e) {
      e.preventDefault();
      var _id = $(this).data("id");
      var mytarget = '.form-' + _id;
      var myhtml = $(mytarget).find('.inner-result').html();
      $('.print-body').html(myhtml);
      window.print();
    });
  }
};

$(document).ready(function () {
  Alfa2017.LS1.setup();
  Alfa2017.Util.setup();
});